import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-stone-50 px-5 py-20 sm:py-28" data-id="element-45" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="9vzmbvjka24">
        <div className="mx-auto max-w-3xl text-center" data-id="element-47" data-mp="58z2bpo1u46x">
          <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-orange-600" data-id="element-48" data-mp="57ecuegldbfx">
            The Math Ready Difference
          </span>
          <h2 className="mt-5 text-3xl font-bold leading-tight tracking-tight text-stone-900 sm:text-4xl" data-id="element-49" data-mp="3rgp9s58bbjis">
            From an Overwhelmed Teacher to a{' '}
            <span className="text-orange-600" data-id="element-50" data-mp="3dj0owxe8wcdq">Confident Guide.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-stone-600 sm:text-base" data-id="element-51" data-mp="3ig0ul776nd4b">
            Give your lessons a clear rhythm, your students more mathematical
            confidence, and yourself the time to enjoy teaching again.
          </p>
        </div>

        <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-1 overflow-hidden rounded-lg border border-stone-200 bg-white sm:grid-cols-3" data-id="element-52" data-mp="1j9ujcajku3mf">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-stone-200 sm:border-l sm:border-t-0' : ''}`} data-id="element-53" data-mp="1szxd4cyivllt" data-mpi={index}>
              <dt className="sr-only" data-id="element-54" data-mp="wapogw2lwwdo">{stat.label}</dt>
              <dd data-id="element-55" data-mp="wcahuid6q99y">
                <span className="block text-3xl font-bold tracking-tight text-orange-600" data-id="element-56" data-mp="wcsng5lqlzuj">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.14em] text-stone-500" data-id="element-57" data-mp="15auup2w2doq9">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-xl border border-stone-200 bg-white" data-id="element-58" data-mp="2gproeq37123y">
          <div className="grid md:grid-cols-2" data-id="element-59" data-mp="2oqh34k4qt1sg">
            <div className="relative border-b border-stone-200 bg-stone-100 p-8 sm:p-10 md:border-b-0 md:border-r" data-id="element-60" data-mp="2ssu9narbd3qa">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-stone-400" data-id="element-61" data-mp="2xrfb1diaxtgb">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-62" data-mp="32qi6c68hclb3" />
              </span>
              <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-stone-500" data-id="element-63" data-mp="254kqkglhiu2u">
                The cost of improvising
              </span>
              <h3 className="mt-3 text-xl font-bold uppercase tracking-wide text-stone-900" data-id="element-64" data-mp="2f1pdwjr2gvl8">
                Before
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-600" data-id="element-65" data-mp="2jsxq1njs6v23">
                What planning from scratch quietly takes from your week.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-66" data-mp="1rb38z1cczrfg">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-lg bg-white px-4 py-3 text-sm text-stone-600" data-id="element-67" data-mp="1jsvlk7mepzmw">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-stone-400" aria-hidden="true" data-id="element-68" data-mp="19u66emlwatac" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-69" data-mp="10usu7m6dzqlx">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-orange-600 text-white" data-id="element-70" data-mp="w2hq074m5ink">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-71" data-mp="r1kbq5mq58rc" />
              </span>
              <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-orange-600" data-id="element-72" data-mp="m6erdb8z025d">
                The Math Ready system
              </span>
              <h3 className="mt-3 text-xl font-bold uppercase tracking-wide text-stone-900" data-id="element-73" data-mp="d3nfxbg3h6dq">
                With Math Ready
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-stone-600" data-id="element-74" data-mp="11wmj1md5vnr2">
                Walk into every lesson with a clear, structured plan.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-75" data-mp="t1gboiy8sxmf">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-lg bg-orange-50 px-4 py-3 text-sm font-medium text-stone-900" data-id="element-76" data-mp="x2ich47t5hqi">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-orange-600" aria-hidden="true" data-id="element-77" data-mp="o3xz8il0o09o" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-stone-200 bg-stone-50 px-6 py-4 text-center text-xs text-stone-500" data-id="element-78" data-mp="24h4zfcjbm0oa">
            A complete system to plan less and teach with more purpose.
          </p>
        </div>
      </div>
    </section>;
}